// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAudioStaticOutlinedSvg from "@fishx/icons-svg/es/asn/PAudioStaticOutlined";
import FishxIcon from '../components/FishxIcon';

var PAudioStaticOutlined = function PAudioStaticOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAudioStaticOutlinedSvg
  }));
};

PAudioStaticOutlined.displayName = 'PAudioStaticOutlined';
export default React.forwardRef(PAudioStaticOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAudioStaticOutlined.js
// module id = 3221
// module chunks = 0